/* eslint-disable prettier/prettier */
import { Select } from "@mui/material";
import styled from "styled-components";

interface ButtonProps {
  width?: string;
  color?: string;
  height?: string;
  border?: string;
}

interface SelectProps {
  width?: string;
}

export const Container = styled.div`
  width: 66%;
  min-height: 50vh;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: left;
  border-radius: 16px;
  border: 1px;
  background-color: #ffffff;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
    ::-webkit-scrollbar {
    width: 0px;
  }
`;

export const TitleHeader = styled.h1`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4000000059604645px;
  text-align: center;
  color: #2d5bff;
`;

export const Line = styled.div`
  width: 100%;
  height: 0px;
  margin: 24px 0;
  border: 1px solid #ececec;
  opacity: 0px;
  border-color: #2d5bff;
`;

export const Simulation = styled.div`
  display: flex;
  justify-content: end;
  gap: 6px;
  margin: 24px 50px 8px;
  align-items: center;
`;

export const ContainerGray = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px;
  gap: 8px;
  border-radius: 8px;
  background-color: #ececec;
`;

export const WhiteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 8px;
  background-color: #ffffff;
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledSelect = styled(Select) <SelectProps>`
  & .MuiOutlinedInput-notchedOutline {
    border: 2px solid #ececec;
    border-radius: 8px;
  }
  width: ${(props) => props.width || "100%"};
`;

export const ContainerLast = styled.div`
  justify-content: space-between;
  width: 100%;
  margin: 24px 0 0;
  gap: 16px;
  margin-top: auto;
  align-items: center;
  padding-top: 34px;
`;

export const Button = styled.button<ButtonProps>`
  display: flex;
  min-width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 8px;
  border-radius: 8px;
  border: ${(props) => (props.border ? props.border : "none")};
  background-color: ${(props) => props.color || "#2d5bff"};
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ButtonBordered = styled.button<ButtonProps>`
  display: flex;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 0;
  border-radius: 8px;
  border: ${(props) => (props.border ? props.border : "1px solid #2d5bff")};
  background-color: ${(props) => props.color || "#2d5bff"};
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const TextButton = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: ${(props) => props.color || "#2d5bff"};
`;

export const FieldFilled: any = styled.div`
  position: relative;
  display: flex;
  width: ${(props: any) => props.width || "100%"};
  height: ${(props: any) => props.height || "100%"};
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #d5d5d5;
  background-color: ${(props: any) => props.color || "#2d5bff"};
  overflow: hidden;

  .hover-buttons {
    display: none;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }

  &:hover {
    .icon-default,
    .text-default {
      display: none;
    }
    .hover-buttons {
      display: flex;
    }
  }
`;

export const ButtonFilled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 8px;
  border-radius: 50%;
  background-color: #ffffff;
  :hover {
    cursor: pointer;
    background-color: #f5f5f5;
  }
`;

export const TextFilledButton = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${(props) => props.color || "#ffffff"};
  max-width: 115px; // Aumente o max-width se necessário
  white-space: nowrap;
  overflow: hidden;
`;

export const ContainerMessage: any = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-top: 16px;
  padding: 16px;
  width: 100%;
  min-height: 76px;
  background-color: ${(props: any) => props.backgroundColor || "#2d5bff"};
`;

export const ResponsavelBadge = styled.div`
  width: fit-content;
  max-width: 100%;
  min-height: 34px;
  border-radius: 8px;
  border: 1px solid #2d5bff;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
`;

export const ResponsavelBadgeText = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #2d5bff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextMessage = styled.p`
  //styleName: LG/Semibold;
  margin-bottom: 8px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  text-align: left;
  color: ${(props) => props.color || "#F43636"};
  overflow-wrap: break-word;
`;

export const SubTextMessage = styled.p`
  //styleName: MD / Regular;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${(props) => props.color || "#F43636"};
  overflow-wrap: break-word;
`;

export const ContainerPopover: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  padding: 8px 8px;
  width: 100%;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;
